import { clearPaymentResume } from "./paymentResume";

export const CHECKIN_PAYMENT_RETURN_STORAGE_KEY = "checkin-payment-return";

const COMPLETED_ONLINE_CHECKIN_STATUSES = new Set([
  "COMPLETED",
  "SYNCED_TO_APALEO",
  "CHECKED_IN",
]);

const isTrue = (source, snakeKey, camelKey) =>
  source?.[snakeKey] === true || source?.[camelKey] === true;

export const isOnlineCheckinComplete = (onlineCheckin = {}) =>
  isTrue(onlineCheckin, "is_complete", "isComplete") ||
  isTrue(onlineCheckin, "should_redirect_to_app", "shouldRedirectToApp") ||
  COMPLETED_ONLINE_CHECKIN_STATUSES.has(String(onlineCheckin.status || "").toUpperCase());

export const clearCompletedCheckinState = (reservationCode) => {
  clearPaymentResume(reservationCode);
  sessionStorage.removeItem(CHECKIN_PAYMENT_RETURN_STORAGE_KEY);
  localStorage.removeItem("reservation-state");
};
